import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScaleLoader = _resolveComponent("ScaleLoader")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_ScaleLoader, { key: 0 }))
    : (_openBlock(), _createBlock(_component_DxDataGrid, {
        key: 1,
        ref: _ctx.dataGridRef,
        "allow-column-reordering": true,
        "allow-column-resizing": true,
        "column-auto-width": true,
        "column-hiding-enabled": true,
        "data-source": _ctx.store,
        "hover-state-enabled": true,
        "remote-operations": _ctx.remoteOperations,
        "row-alternation-enabled": true,
        "show-borders": true,
        "show-column-lines": true,
        "show-row-lines": false
      }, {
        "date-cell-template": _withCtx(({ data }) => [
          _createElementVNode("p", null, _toDisplayString(_ctx.parseDate(data.data.data_date)), 1)
        ]),
        "distance-cell-template": _withCtx(({ data }) => [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.distance.map')) + ": " + _toDisplayString(data.data.distance) + " [km]", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.distance.can')) + ": " + _toDisplayString(data.data.can_distance) + " [km]", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.distance.placeStart')) + ": " + _toDisplayString(data.data.place_start), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.distance.placeStop')) + ": " + _toDisplayString(data.data.place_stop), 1)
        ]),
        "odometer-cell-template": _withCtx(({ data }) => [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.odometer.start')) + ": " + _toDisplayString(data.data.odometer_start) + " [km]", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.odometer.stop')) + ": " + _toDisplayString(data.data.odometer_stop) + " [km]", 1)
        ]),
        "time-cell-template": _withCtx(({ data }) => [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.time.start')) + ": " + _toDisplayString(_ctx.getHumanDateTime(data.data.time_start)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.time.stop')) + ": " + _toDisplayString(_ctx.getHumanDateTime(data.data.time_stop)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.time.ignition')) + ": " + _toDisplayString(_ctx.secondsToHoursMinutes(data.data.ignition_time)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.time.drive')) + ": " + _toDisplayString(_ctx.secondsToHoursMinutes(data.data.drive_time)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.time.work')) + ": " + _toDisplayString(_ctx.secondsToHoursMinutes(data.data.work_time)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.time.rest')) + ": " + _toDisplayString(_ctx.secondsToHoursMinutes(data.data.rest_time)), 1)
        ]),
        "fuel-cell-template": _withCtx(({ data }) => [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.fuel.fuelStart')) + ": " + _toDisplayString(data.data.fuel_start) + " [L]", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.fuel.fuelStop')) + ": " + _toDisplayString(data.data.fuel_stop) + " [L]", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.fuel.fuelUsed')) + ": " + _toDisplayString(data.data.fuel_used) + " [L]", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.history.dailySummary.dataGrids.fuel.fuelRate')) + ": " + _toDisplayString(data.data.fuel_rate) + " [L/100]", 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxHeaderFilter, { visible: true }),
          _createVNode(_component_DxPaging, {
            "page-index": 0,
            "page-size": 25
          }),
          _createVNode(_component_DxPager, {
            "allowed-page-sizes": [10, 20, 25],
            "show-info": true,
            "show-navigation-buttons": true,
            "show-page-size-selector": true
          }),
          _createVNode(_component_DxFilterRow, { visible: true }),
          _createVNode(_component_DxColumnFixing, { enabled: true }),
          _createVNode(_component_DxColumn, {
            caption: _ctx.$t('components.history.dailySummary.dataGrids.date'),
            "cell-template": "date-cell-template"
          }, null, 8, ["caption"]),
          _createVNode(_component_DxColumn, {
            caption: _ctx.$t('components.history.dailySummary.dataGrids.imei'),
            "data-field": "imei"
          }, null, 8, ["caption"]),
          _createVNode(_component_DxColumn, {
            caption: _ctx.$t('components.history.dailySummary.dataGrids.distance.distance'),
            "cell-template": "distance-cell-template"
          }, null, 8, ["caption"]),
          _createVNode(_component_DxColumn, {
            caption: _ctx.$t('components.history.dailySummary.dataGrids.odometer.odometer'),
            "cell-template": "odometer-cell-template"
          }, null, 8, ["caption"]),
          _createVNode(_component_DxColumn, {
            caption: _ctx.$t('components.history.dailySummary.dataGrids.time.time'),
            "cell-template": "time-cell-template"
          }, null, 8, ["caption"]),
          _createVNode(_component_DxColumn, {
            caption: _ctx.$t('components.history.dailySummary.dataGrids.fuel.fuel'),
            "cell-template": "fuel-cell-template"
          }, null, 8, ["caption"])
        ]),
        _: 1
      }, 8, ["data-source", "remote-operations"]))
}